/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clean_Smug_Panda_RippleInputs */

const fr_clean_smug_panda_ripple = /** @type {(inputs: Clean_Smug_Panda_RippleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

/**

* @param {Clean_Smug_Panda_RippleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const clean_smug_panda_ripple = /** @type {((inputs?: Clean_Smug_Panda_RippleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clean_Smug_Panda_RippleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_clean_smug_panda_ripple(inputs)
});